<template>
  <v-dialog v-model="open" max-width="420" persistent @keydown.esc="$emit('close')">
    <v-card style="border-radius:16px; overflow:hidden;">

      <div class="modal-header">
        <v-icon color="#00BCD4" size="22" class="mr-2">mdi-calendar-range</v-icon>
        <span class="modal-title">Datumi računa</span>
      </div>

      <div class="modal-body">

        <!-- Datum isporuke -->
        <div class="date-section">
          <div class="date-label">
            <v-icon size="15" color="#00BCD4" class="mr-2">mdi-truck-delivery-outline</v-icon>
            Datum isporuke
          </div>
          <v-menu v-model="menuDelivery" offset-y :close-on-content-click="false" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <button class="period-pill date-pill" v-bind="attrs" v-on="on">
                <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                {{ formatDate(localDeliveryDate) }}
              </button>
            </template>
            <v-date-picker
              v-model="localDeliveryDate"
              no-title scrollable
              :locale="'hr'"
              @input="menuDelivery = false"
            />
          </v-menu>
        </div>

        <!-- Datum valute + broj dana — samo T/V/P -->
        <div v-if="showValueDate" class="date-section">
          <div class="date-label">
            <v-icon size="15" color="#00BCD4" class="mr-2">mdi-calendar-check-outline</v-icon>
            Datum valute
          </div>

          <!-- Broj dana -->
          <div class="days-row">
            <span class="days-label">Broj dana:</span>
            <div class="period-pills">
              <button
                v-for="d in quickDays"
                :key="d"
                class="period-pill"
                :class="{ active: localPaymentDue === d }"
                @click="onDaysChange(d)"
              >{{ d }}</button>
            </div>
            <v-combobox
              v-model="localPaymentDue"
              :items="paymentDues"
              outlined dense hide-details
              class="days-combobox"
              @change="onDaysChange($event)"
            />
          </div>

          <!-- Datum valute picker -->
          <v-menu v-model="menuValue" offset-y :close-on-content-click="false" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <button class="period-pill date-pill" v-bind="attrs" v-on="on">
                <v-icon x-small class="mr-1">mdi-calendar-check</v-icon>
                {{ formatDate(localValueDate) }}
              </button>
            </template>
            <v-date-picker
              v-model="localValueDate"
              no-title scrollable
              :locale="'hr'"
              @input="menuValue = false"
            />
          </v-menu>
        </div>

      </div>

      <div class="modal-footer">
        <button class="btn-cancel" @click="$emit('close')">Odustani</button>
        <button class="btn-confirm" @click="onConfirm">
          <v-icon size="16" color="white" class="mr-1">mdi-check</v-icon>
          Primijeni
        </button>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShopDatesModal',

  props: {
    open: { type: Boolean, default: false },
    deliveryDate: { type: Number, default: () => Date.now() },
    valueDate: { type: Number, default: () => Date.now() },
    selectedPaymentDue: { type: Number, default: 8 },
    paymentDues: { type: Array, default: () => [1, 2, 3, 5, 6, 7, 8, 9, 10, 12, 14, 15, 30, 60, 120] },
    showValueDate: { type: Boolean, default: true }
  },

  data () {
    return {
      localDeliveryDate: '',
      localValueDate: '',
      localPaymentDue: 8,
      menuDelivery: false,
      menuValue: false,
      quickDays: [8, 15, 30, 60]
    }
  },

  watch: {
    open (val) {
      if (val) {
        this.localDeliveryDate = this.tsToDateStr(this.deliveryDate)
        this.localValueDate = this.tsToDateStr(this.valueDate)
        this.localPaymentDue = this.selectedPaymentDue
      }
    }
  },

  methods: {
    tsToDateStr (ts) {
      return ts ? new Date(ts).toISOString().substr(0, 10) : ''
    },
    dateStrToTs (str) {
      return str ? new Date(str).getTime() : Date.now()
    },
    formatDate (d) {
      if (!d) return '—'
      const [y, m, day] = d.split('-')
      return `${day}.${m}.${y}`
    },
    calcValueDate (days) {
      const date = new Date(this.dateStrToTs(this.localDeliveryDate) || Date.now())
      date.setDate(date.getDate() + Number(days))
      return this.tsToDateStr(date.getTime())
    },
    onDaysChange (val) {
      this.localPaymentDue = Number(val)
      this.localValueDate = this.calcValueDate(val)
    },
    onConfirm () {
      this.$emit('update:deliveryDate', this.dateStrToTs(this.localDeliveryDate))
      this.$emit('update:valueDate', this.dateStrToTs(this.localValueDate))
      this.$emit('update:selectedPaymentDue', this.localPaymentDue)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-header {
  display: flex; align-items: center;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #F1F5F9;
}
.modal-title { font-size: 16px; font-weight: 700; color: #1e293b; }

.modal-body { padding: 20px 24px 8px; display: flex; flex-direction: column; gap: 20px; }

.date-section { display: flex; flex-direction: column; gap: 10px; }
.date-label {
  display: flex; align-items: center;
  font-size: 12px; font-weight: 700; color: #334155;
}

/* Period pill — identičan NapojniceReport */
.period-pills { display: flex; gap: 6px; flex-wrap: wrap; }
.period-pill {
  display: inline-flex; align-items: center;
  padding: 6px 14px; border-radius: 20px;
  font-size: 13px; font-weight: 500; color: #6B7280;
  cursor: pointer; border: 1.5px solid #E2E8F0;
  background: #fff; transition: all 0.15s;
  white-space: nowrap; outline: none;
}
.period-pill:hover { border-color: #00BCD4; color: #00838F; background: rgba(0,188,212,0.05); }
.period-pill.active { border-color: rgba(0,188,212,0.5); background: rgba(0,188,212,0.1); color: #00838F; font-weight: 600; }
.date-pill { font-variant-numeric: tabular-nums; letter-spacing: 0.3px; }

/* Broj dana row */
.days-row {
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
}
.days-label { font-size: 11px; font-weight: 600; color: #94A3B8; white-space: nowrap; }
/* Combobox stiliziran kao period-pill */
.days-combobox { max-width: 90px; }
.days-combobox >>> .v-input__slot {
  border-radius: 20px !important;
  min-height: 34px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.days-combobox >>> fieldset { border-color: #E2E8F0 !important; }
.days-combobox >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }

.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 10px; padding: 16px 24px 20px;
  border-top: 1px solid #F1F5F9;
}
.btn-cancel {
  padding: 12px 22px;
  background: #F8FAFC; border: 1.5px solid #E2E8F0;
  border-radius: 10px; font-size: 13px; font-weight: 600; color: #64748B;
  cursor: pointer; transition: all 0.15s; text-transform: none; letter-spacing: 0;
}
.btn-cancel:hover { background: #F1F5F9; border-color: #CBD5E1; color: #334155; }
.btn-confirm {
  display: flex; align-items: center; gap: 6px;
  padding: 12px 24px;
  background-color: #00BCD4 !important; background: #00BCD4 !important;
  color: #fff !important; border-radius: 10px; border: none !important;
  font-size: 13px; font-weight: 700; cursor: pointer; letter-spacing: 0;
  box-shadow: 0 2px 8px rgba(0,188,212,0.35);
  transition: background-color 0.15s;
}
.btn-confirm:hover { background-color: #0097A7 !important; background: #0097A7 !important; }
</style>
